import Task from "@homer.core/task";

function parse(identifier, resolve, reject, value) {
    resolve(JSON.parse(value));
}

export default new Task(parse);
